import { createStore } from 'vuex';

import i18n from '@/i18n';
import { getModules } from './hooks/useStore';
import { StoreState } from './models/store.interface';

const contractRequiredModules = import.meta.glob('../core/collections/contracts-api/*/*.store.ts', { eager: true });
const contractApiModules = getModules(contractRequiredModules);

const printRequiredModules = import.meta.glob('../core/collections/print-api/*/*.store.ts', { eager: true });
const printApiModules = getModules(printRequiredModules);

const storeRequiredModules = import.meta.glob('../core/collections/store/*/*.store.ts', { eager: true });
const storeModules = getModules(storeRequiredModules);

const store = createStore<StoreState>({
   state: {
      weekdays: [
         { id: 1, name: () => i18n.global.t('general.weekdays.monday') },
         { id: 2, name: () => i18n.global.t('general.weekdays.tuesday') },
         { id: 3, name: () => i18n.global.t('general.weekdays.wednesday') },
         { id: 4, name: () => i18n.global.t('general.weekdays.thursday') },
         { id: 5, name: () => i18n.global.t('general.weekdays.friday') },
         { id: 6, name: () => i18n.global.t('general.weekdays.saturday') },
         { id: 7, name: () => i18n.global.t('general.weekdays.sunday') },
      ],
      isProduction: ['prod'].includes(import.meta.env.VITE_APP_ENV),
      isDev: !['acc', 'prod', 'release'].includes(import.meta.env.VITE_APP_ENV),
   },
   getters: {
      weekdays: (state: StoreState) => state.weekdays.map((weekday) => ({ ...weekday, name: weekday.name() })),
   },
   mutations: {},
   actions: {},
   modules: { ...contractApiModules, ...storeModules, print: printApiModules },
});

export default store;
